<app-pageheader [Parent]="this">
  @if (ShowUpload) {
    <button type="button" class="button is-primary is-outlined ml-2" [disabled]="Processing" (click)="OpenUpload()">
      <span class="icon-text">
        <span>{{ Provider?.UploadUIButtonText || 'Upload Collections Results' }}</span>
        <span class="icon">
          <i class="fa fa-upload"></i>
        </span>
      </span>
    </button>
  }
  @if (ShowCollectionsActions) {
    <button class="button is-primary ml-2" [disabled]="!CanProcess" (click)="ProcessSelected()">
      <span class="icon-text">
        <span>{{ Provider?.UIButtonText || 'Download CSV' }}</span>
        <span class="icon">
          <i class="fa fa-download"></i>
        </span>
      </span>
    </button>
  }
  @if (Provider && !Provider.IsConfigured) {
    <span class="tag is-warning is-light ml-2">
      No Collections provider configured
    </span>
  }
</app-pageheader>

<input
  #collectionsUploadInput
  type="file"
  [attr.accept]="UploadAcceptAttr"
  style="display:none"
  (change)="OnUploadSelected($event)" />

  <div class="modal" [ngClass]="{'is-active': ShowImportSummaryModal}">
    <div class="modal-background" (click)="CloseImportSummaryModal()"></div>
    <div class="modal-card">
      <header class="modal-card-head">
        <p class="modal-card-title">Collections Import Summary</p>
        <button class="delete" aria-label="close" (click)="CloseImportSummaryModal()"></button>
      </header>
      <section class="modal-card-body">
        @if (LastImportErrorMessage) {
          <div class="notification is-danger is-light">
            <strong>Import failed</strong>
            @if (LastImportErrorCode) {
              <span>({{LastImportErrorCode}})</span>
            }
            <div class="mt-2">{{LastImportErrorMessage}}</div>
          </div>
        }

        @if (LastImportSummary; as s) {
          <div>
            <div class="content">
              <ul>
                <li><strong>Rows in Uploaded File</strong>: {{ImportRowsProcessed}}</li>
                <li><strong>Payments applied</strong>: {{ImportPaymentsApplied}}</li>
              </ul>
            </div>
            @if (s.Warnings?.length) {
              <div class="notification is-warning is-light">
                <strong>Warnings ({{s.Warnings.length}})</strong>
                <ul class="mt-2">
                  @for (w of s.Warnings; track w) {
                    <li>{{w}}</li>
                  }
                </ul>
              </div>
            }
          </div>
        }
      </section>
      <footer class="modal-card-foot">
        <button class="button is-primary" (click)="CloseImportSummaryModal()">Close</button>
      </footer>
    </div>
  </div>

  <app-datalistview
    [Columns]="Columns"
    [ShowMap]="false"
    ApiUrl="enforcement/collections/records/searches"
    [AllowEdit]="true"
    EditUrl="enforcement/citations/issued/:id"
    [AllowSelectBoxes]="ShowCollectionsActions"
    [SelectBoxCanShow]="CanSelectRow"
    [SelectedItems]="SelectedItems"
    (SelectBoxChanged)="OnSelectBoxChanged($event)"
    [AllowAllResults]="true">
    <div class="level mb-0">
      <div class="level-left">
        <app-filter-set>
          <div app-search-filter></div>
          <div app-collections-state-filter></div>
          <div app-search-button></div>
        </app-filter-set>
      </div>
      @if (ShowCollectionsActions && HasSelectableRows) {
        <div class="level-right">
          <div class="level-item">
            <button
              type="button"
              [disabled]="Processing"
              (click)="ToggleSelectAll()"
              class="button is-rounded"
              [ngClass]="AllItemsSelected ? 'is-danger is-light' : 'is-info is-light'">
              <span class="icon-text">
                <span>{{ AllItemsSelected ? 'Deselect all' : 'Select all missing' }}</span>
                <span class="icon">
                  <i class="fa" [ngClass]="AllItemsSelected ? 'fa-minus-square-o' : 'fa-check-square-o'"></i>
                </span>
              </span>
            </button>
          </div>
        </div>
      }
    </div>
  </app-datalistview>

